import React, { useState, useEffect  } from 'react';
import { Settings, User, Medal, Award, Clock, Heart, Edit, Save, ChevronRight } from 'lucide-react';
import Navigation from '../components/common/Navigation';
import api from '../request'; // Axios instance
import {  Link } from 'react-router-dom';

const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState('personal');
  const [isEditing, setIsEditing] = useState(false);

  const [userData, setUserData] = useState({
    firstName: 'John',
    lastName: 'Walker',
    email: 'john.walker@example.com',
    phone: '+1 (555) 123-4567',
    dateOfBirth: '1985-04-15',
    address: '123 Walking Lane, Stepville, ST 12345',
    bio: 'Passionate about walking and staying active. I love to explore new trails and participate in walking challenges.',
    avatar: '/api/placeholder/150/150'
  });

  const [fitnessStats, setFitnessStats] = useState({
    totalSteps: '1,452,678',
    averageDailySteps: '8,756',
    totalDistance: '984.5 km',
    caloriesBurned: '87,542 kcal',
    totalActiveTime: '294 hours',
    longestWalk: '15.8 km',
    averagePace: '14 min/km',
    joinDate: 'January 15, 2024'
  });

  const [achievements, setAchievements] = useState([
    { id: 1, name: 'Early Bird', description: 'Complete 10 morning walks', icon: <Clock size={24} className="text-accent" />, date: 'Feb 12, 2024', progress: '100%' },
    { id: 2, name: 'Step Master', description: 'Reach 250,000 lifetime steps', icon: <Medal size={24} className="text-accent" />, date: 'Mar 5, 2024', progress: '100%' },
    { id: 3, name: 'Challenge Champion', description: 'Win 5 group challenges', icon: <Award size={24} className="text-accent" />, date: 'Mar 28, 2024', progress: '100%' },
    { id: 4, name: 'Marathon Walker', description: 'Walk 42 km in a single week', icon: <Medal size={24} className="text-accent" />, date: 'In progress', progress: '65%' },
    { id: 5, name: 'Consistency King', description: 'Meet daily step goal for 30 consecutive days', icon: <Heart size={24} className="text-accent" />, date: 'In progress', progress: '50%' }
  ]);

  const [connections, setConnections] = useState([
    { id: 1, name: 'Sarah Johnson', steps: '9,876', avatar: '/api/placeholder/40/40' },
    { id: 2, name: 'Michael Chen', steps: '8,543', avatar: '/api/placeholder/40/40' },
    { id: 3, name: 'Emma Wilson', steps: '7,654', avatar: '/api/placeholder/40/40' },
    { id: 4, name: 'James Taylor', steps: '6,789', avatar: '/api/placeholder/40/40' }
  ]);


  useEffect(() => {
  const fetchProfile = async () => {
    try {
      const { data } = await api.get('/user/profile');

      setUserData({
        firstName: data.profile.firstName,
        lastName: data.profile.lastName,
        email: data.profile.email,
        phone: data.profile.phone,
        dateOfBirth: data.profile.dateOfBirth,
        address: data.profile.address,
        bio: data.profile.bio,
        avatar: data.profile.avatar
      });

      setFitnessStats({
        totalSteps: data.fitnessStats.totalSteps,
        averageDailySteps: data.fitnessStats.averageDailySteps,
        totalDistance: data.fitnessStats.totalDistance,
        caloriesBurned: data.fitnessStats.caloriesBurned,
        totalActiveTime: data.fitnessStats.totalActiveTime,
        longestWalk: data.fitnessStats.longestWalk,
        averagePace: data.fitnessStats.averagePace,
        joinDate: data.fitnessStats.joinDate
      });

    } catch (err) {
      console.error('Failed to fetch profile:', err);
    }
  };

  fetchProfile();
}, []); 

  const handleInputChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsEditing(false);
    // In a real app, you would save to an API here
  };

  const renderPersonalInfo = () => (
    <div className="bg-white rounded-xl shadow-sm p-6">
      {isEditing ? (
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
              <input
                type="text"
                name="firstName"
                value={userData.firstName}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
              <input
                type="text"
                name="lastName"
                value={userData.lastName}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={userData.email}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
              <input
                type="tel"
                name="phone"
                value={userData.phone}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
              <input
                type="date"
                name="dateOfBirth"
                value={userData.dateOfBirth}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
              <input
                type="text"
                name="address"
                value={userData.address}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Bio</label>
              <textarea
                name="bio"
                value={userData.bio}
                onChange={handleInputChange}
                rows="3"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div className="flex justify-end">
            <button 
              type="button"
              onClick={() => setIsEditing(false)}
              className="mr-2 px-4 py-2 border border-gray-300 rounded-md text-gray-700"
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="flex items-center px-4 py-2 bg-primary text-white rounded-md"
            >
              <Save size={16} className="mr-2" />
              Save Changes
            </button>
          </div>
        </form>
      ) : (
        <>
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center">
              <img src='/images/default-profile.jpg' alt="Profile" className="w-24 h-24 rounded-full mr-4" />
              <div>
                <h2 className="text-2xl font-semibold">
                  {userData.firstName.charAt(0).toUpperCase() + userData.firstName.slice(1)}{' '}
                  {userData.lastName.charAt(0).toUpperCase() + userData.lastName.slice(1)}
                </h2>
                <p className="text-gray-500">Premium Member</p>
              </div>
            </div>

            <Link
                        
                        to='/settings'
                     >

                          <button 
                      
                      className="flex items-center px-3 py-1 text-sm bg-secondary text-white rounded-md"
                    >
                      <Edit size={14} className="mr-1" />
                      Edit
                    </button>
                      
            </Link>
          
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8">
            <div>
              <h3 className="text-sm font-medium text-gray-500">Email</h3>
              <p>{userData.email}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-500">Phone</h3>
              <p>{userData.phone}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-500">Date of Birth</h3>
              <p>{new Date(userData.dateOfBirth).toLocaleDateString()}</p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-500">Address</h3>
              <p>{userData.address}</p>
            </div>
            <div className="md:col-span-2">
              <h3 className="text-sm font-medium text-gray-500">Bio</h3>
              <p>{userData.bio}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );

  const renderStats = () => (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-xl font-semibold mb-4">Fitness Statistics</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Total Steps</p>
          <p className="text-xl font-bold">{fitnessStats.totalSteps}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Average Daily Steps</p>
          <p className="text-xl font-bold">{fitnessStats.averageDailySteps}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Total Distance</p>
          <p className="text-xl font-bold">{fitnessStats.totalDistance}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Calories Burned</p>
          <p className="text-xl font-bold">{fitnessStats.caloriesBurned}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Total Active Time</p>
          <p className="text-xl font-bold">{fitnessStats.totalActiveTime}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Longest Walk</p>
          <p className="text-xl font-bold">{fitnessStats.longestWalk}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Average Pace</p>
          <p className="text-xl font-bold">{fitnessStats.averagePace}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-500">Member Since</p>
          <p className="text-xl font-bold">{fitnessStats.joinDate}</p>
        </div>
      </div>
    </div>
  );

  const renderAchievements = () => (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-xl font-semibold mb-4">Achievements</h2>
      <div className="space-y-4">
        {achievements.map(achievement => (
          <div key={achievement.id} className="border rounded-lg p-4">
            <div className="flex items-start">
              <div className="p-2 bg-gray-100 rounded-full mr-3">
                {achievement.icon}
              </div>
              <div className="flex-1">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="font-medium">{achievement.name}</h3>
                    <p className="text-sm text-gray-500">{achievement.description}</p>
                  </div>
                  <span className="text-sm text-gray-500">{achievement.date}</span>
                </div>
                {achievement.progress !== '100%' && (
                  <div className="mt-2">
                    <div className="h-2 w-full bg-gray-100 rounded-full mt-1">
                      <div 
                        className="h-full bg-primary rounded-full" 
                        style={{ width: achievement.progress }}
                      />
                    </div>
                    <p className="text-xs text-right mt-1 text-gray-500">{achievement.progress} complete</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderConnections = () => (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Walking Buddies</h2>
        <button className="text-secondary flex items-center text-sm">
          See all
          <ChevronRight size={16} />
        </button>
      </div>
      
      <div className="space-y-4">
        {connections.map(connection => (
          <div key={connection.id} className="flex items-center justify-between p-3 border-b last:border-0">
            <div className="flex items-center">
              <img src={connection.avatar} alt={connection.name} className="w-10 h-10 rounded-full mr-3" />
              <div>
                <h3 className="font-medium">{connection.name}</h3>
                <p className="text-xs text-gray-500">{connection.steps} steps today</p>
              </div>
            </div>
            <button className="text-sm text-secondary">View Profile</button>
          </div>
        ))}
      </div>
      
      <button className="mt-4 w-full py-2 border border-primary text-primary rounded-md">
        Find More Walking Buddies
      </button>
    </div>
  );

  return (
    <div className=" h-screen bg-background-light">
      {/* Sidebar Navigation */}
      {/* <div className="hidden md:flex flex-col w-64 bg-white border-r p-4">
        <div className="text-2xl font-bold text-primary mb-8">Stepping4Life</div>
         */}
        <nav className="hidden lg:flex fixed left-0 top-0 bottom-0 w-64 bg-white shadow-sm z-20 flex-col">
      <Navigation />
      </nav>
     
        
        {/* <div className="mt-auto pt-4 border-t">
          <div className="flex items-center p-4">
            <img src="/api/placeholder/40/40" alt="Profile" className="w-10 h-10 rounded-full mr-3" />
            <div>
              <p className="font-medium">John Walker</p>
              <p className="text-sm text-gray-500">Premium Member</p>
            </div>
          </div>
        </div>
      </div> */}
      
      {/* Main Content */}
      <div className="flex-1 max-w-7xl lg:ml-64 overflow-auto">

        <header className="bg-white p-4 shadow-sm flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">Profile</h1>
            <p className="text-gray-500">Manage your profile and view achievements</p>
          </div>
          <div className="flex items-center space-x-4">
            <div className="relative">
              <span className="absolute top-0 right-0 h-2 w-2 bg-accent rounded-full"></span>
              
                <Link
                        
                        to='/settings'
                     >

                          <button className="p-2 rounded-full bg-gray-100">
                          <Settings size={20} />
                        </button>
                      
               </Link>
          
              
            </div>
            <img src='/images/default-profile.jpg' alt="Profile" className="w-10 h-10 rounded-full" />
          </div>
        </header>
        
        <div className="p-6">
          {/* Profile Tabs */}
          <div className="mb-6 border-b">
            <div className="flex space-x-6">
              <button
                className={`pb-3 ${activeTab === 'personal' ? 'text-primary border-b-2 border-primary font-medium' : 'text-gray-500'}`}
                onClick={() => setActiveTab('personal')}
              >
                Personal Info
              </button>
              <button
                className={`pb-3 ${activeTab === 'stats' ? 'text-primary border-b-2 border-primary font-medium' : 'text-gray-500'}`}
                onClick={() => setActiveTab('stats')}
              >
                Statistics
              </button>
              {/* <button
                className={`pb-3 ${activeTab === 'achievements' ? 'text-primary border-b-2 border-primary font-medium' : 'text-gray-500'}`}
                onClick={() => setActiveTab('achievements')}
              >
                Achievements
              </button>
              <button
                className={`pb-3 ${activeTab === 'connections' ? 'text-primary border-b-2 border-primary font-medium' : 'text-gray-500'}`}
                onClick={() => setActiveTab('connections')}
              >
                Connections
              </button> */}
            </div>
          </div>
          
          {/* Tab Content */}
          <div className="space-y-6">
            {activeTab === 'personal' && renderPersonalInfo()}
            {activeTab === 'stats' && renderStats()}
            {activeTab === 'achievements' && renderAchievements()}
            {activeTab === 'connections' && renderConnections()}
          </div>
        </div>

      </div>
      <div className="md:hidden block sticky bottom-0 z-50 bg-white border-t border-gray-200 p-2">
        <Navigation orientation='horizontal' />
      </div>
    </div>
  );
};

export default ProfilePage;